export enum ApiKeyExpirations {
  THIRTY = '30',
  SIXTY = '60',
  NINETY = '90',
  NINTY = '90',
  NEVER = '-1',
  CUSTOM = 'custom',
}

export enum ApiKeyStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  NEVER_EXPIRES = 'never_expires',
}

export enum PublicApiVersions {
  // 2025
  MARCH_2025 = '2025-03',
}

export const PublicApiListLimits = {
  [PublicApiVersions.MARCH_2025]: {
    maxLimit: 200,
    defaultLimit: 100,
  },
}
